import React from 'react';
import Switcher from './Switcher';
import panel from './PanelMobile.module.scss';
// import { ReactComponent as Search } from '../styles/icon/search.svg';
import { Link } from 'react-router-dom';
import Button from '../elements/Button/Button';
import Routes from './Routes';
import settings from '../pages/apps/Settings.module.scss';
import { ReactComponent as ArrowBack } from '../styles/icon/arrow-back.svg';

const PanelContainerMobile = () => {
  return (
    <div className={panel.panel}>
      <div className={panel.panel__container}>
        <div className={settings.settings__back}>
          <Link to={Routes.routes.APPLIST.path}>
            <Button name="Back" variant="back">
              <ArrowBack />
            </Button>
          </Link>
        </div>
        <div className={panel.panel__right}>
          {/* <i className={panel.panel__search}>
            <Search />
          </i> */}
          <Switcher handleDiameter={24} height={16} width={38} />
        </div>
      </div>
    </div>
  );
};

export default PanelContainerMobile;
